import { render } from "./PickupDetails.vue?vue&type=template&id=d04144e4"
import script from "./PickupDetails.vue?vue&type=script&lang=js"
export * from "./PickupDetails.vue?vue&type=script&lang=js"
script.render = render

export default script